import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Beaker01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "beaker01",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 2v4.6605c0 .2172 0 .3258-.0331.4121a.4692.4692 0 0 1-.1383.198c-.0697.0608-.1827.1022-.4085.185C6.5489 8.5072 4.5 11.2643 4.5 14.5c0 4.1421 3.3579 7.5 7.5 7.5s7.5-3.3579 7.5-7.5c0-3.2356-2.0489-5.9927-4.9201-7.0445-.2258-.0827-.3388-.124-.4085-.1849a.4688.4688 0 0 1-.1383-.198C14 6.9863 14 6.8776 14 6.6605V2.0001M8.5 2h7"
    })
  }));
};
export default Beaker01;